import { FaHome, FaFileAlt } from "react-icons/fa";
import { ImStatsDots } from "react-icons/im";
import { FiUsers } from "react-icons/fi";
import { RiAdminLine } from "react-icons/ri";
import { MdLocalOffer } from "react-icons/md";
import { BsCartFill } from "react-icons/bs";

export const links = [
  {
    name: "Dashboard",
    path: "/",
    icon: <FaHome />,
  },
  {
    name: "Oferty",
    path: "/offers",
    icon: <MdLocalOffer />,
  },
  {
    name: "Produkty",
    path: "/products",
    icon: <BsCartFill />,
  },
  {
    name: "Umowy",
    icon: <FaFileAlt />,
    active: false,
    dropdown: [
      {
        name: "Dodawanie umowy",
        path: "/contracts/dashboard",
        icon: "DU",
      },
      {
        name: "Lista umów",
        path: "/contracts/list",
        icon: "LU",
      },
    ],
  },
  {
    name: "Raporty",
    path: "/reports",
    icon: <ImStatsDots />,
  },
  {
    name: "Klienci",
    path: "/contractors",
    icon: <FiUsers />,
  },
  {
    name: "Operatorzy",
    path: "/operators",
    icon: <RiAdminLine />,
  },
];
